import React from "react";

/**
 * The tab's backdrop: four drifting aurora ribbons, a blueprint grid, the scan
 * line, and the vignette that sinks all three into the page. Purely decorative —
 * nothing here reads data, and it is `aria-hidden` from top to bottom.
 *
 * ABSOLUTE, NOT FIXED. The mockup pins its backdrop to the viewport; inside the
 * app shell that would paint over the sidebar and the header, so the layers are
 * absolute within `.sa-root` instead (see automation.css).
 *
 * NO CANVAS, SO NO JS. Unlike the Supernova starfield this is CSS end to end,
 * which means `prefers-reduced-motion: reduce` in the stylesheet is the whole of
 * the reduced-motion story: the ribbons stop drifting and the scan band is
 * removed outright rather than left as a static stripe.
 */
const AutomationBackdrop = () => (
  <div aria-hidden="true" data-testid="automation-backdrop">
    <div className="sa-aurora">
      <div className="sa-rib sa-r1" />
      <div className="sa-rib sa-r2" />
      <div className="sa-rib sa-r3" />
      <div className="sa-rib sa-r4" />
    </div>
    <div className="sa-grid" />
    <div className="sa-scan" />
    <div className="sa-vig" />
  </div>
);

export default AutomationBackdrop;
